import { render, staticRenderFns } from "./ModalProjectCreate.vue?vue&type=template&id=f0f4bc54"
import script from "./ModalProjectCreate.vue?vue&type=script&lang=js"
export * from "./ModalProjectCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports